import React from 'react';
import { getCustomizedStructure } from 'utils/common';
import ComponentNoDataFound from 'components/ComponentNoDataFound';
import FolderName from './FolderName';
import FileName from './FileName';
import { orderBy } from 'lodash';

export default function FolderStructure({
  activeEventKey,
  setActiveEventKeyAccordian,
  folderStructure,
  handleFolderClick,
  downloadArtefactLink,
}) {
  const sortedFiles = orderBy(folderStructure?.files, ['order']);

  return (
    <div onToggle={setActiveEventKeyAccordian}>
      {sortedFiles?.length > 0 ? (
        sortedFiles?.map((folder, index) => {
          return (
            <div key={index}>
              {folder.type === 'folder' ? (
                <div>
                  <FolderName
                    handleFolderClick={handleFolderClick}
                    folder={folder}
                  />
                  {folder.isOpen && (
                    <div className="ltw-border-l ltw-border-gray-26 ltw-pl-40px">
                      <FolderStructure
                        folderStructure={getCustomizedStructure(folder)}
                        activeEventKey={activeEventKey}
                        setActiveEventKeyAccordian={setActiveEventKeyAccordian}
                        handleFolderClick={handleFolderClick}
                        downloadArtefactLink={downloadArtefactLink}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <FileName
                  folder={folder}
                  downloadArtefactLink={downloadArtefactLink}
                />
              )}
            </div>
          );
        })
      ) : (
        <ComponentNoDataFound
          type="nodataavialable"
          message="No Files/Folder Found"
        />
      )}
    </div>
  );
}
